"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _animate = _interopRequireDefault(require("animate.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up6"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _keepScrollPosition = _interopRequireDefault(require("../../helpers/keepScrollPosition.js"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../reducers/admin.js");
var _admin2 = require("../../selectors/admin.js");
var _CycleForm = _interopRequireDefault(require("./CycleForm"));
var _CycleCard = _interopRequireDefault(require("./CycleList/CycleCard"));
var _DeployTrack = _interopRequireDefault(require("../DeployTrack"));
var _style = _interopRequireDefault(require("./style.css"));
var _useEnsureDeploymentIds = _interopRequireDefault(require("../../hooks/useEnsureDeploymentIds"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Fortress = window.cccisd.fortress;
var Deploy = function Deploy(_ref) {
  var dispatch = _ref.dispatch,
    project = _ref.project,
    projectAssignments = _ref.projectAssignments,
    projectLinks = _ref.projectLinks,
    assignmentId = _ref.assignmentId,
    deployment = _ref.deployment;
  if (!Fortress.hasAnyAccess(_questPermissionsByArea["default"].deploy.permissions, project.groupId)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
  }
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showArrow = _useState2[0],
    setShowArrow = _useState2[1];
  var match = (0, _cccisdReactRouter.useRouteMatch)();
  var currentAssignment = projectAssignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  (0, _useEnsureDeploymentIds["default"])();

  // Deploy tab filters out all child deployments of a repeatable Parent,
  // so make sure the currently selected one is always a Parent (cannot edit a Child)
  if (deployment !== null && deployment !== void 0 && deployment.parentDeploymentId) {
    var firstParentDeployment = Array.isArray(currentAssignment.deploymentList) && currentAssignment.deploymentList.find(function (dep) {
      return !dep.parentDeploymentId;
    });
    var selected = firstParentDeployment !== null && firstParentDeployment !== void 0 && firstParentDeployment.deploymentId ? [firstParentDeployment.deploymentId] : [0];
    dispatch((0, _admin.setSelectedDeploymentIds)(selected));
    dispatch((0, _admin.setCurrentDeploymentIds)(selected));
    return /*#__PURE__*/_react["default"].createElement("span", null);
  }
  var hasSurveys = currentAssignment && Array.isArray(currentAssignment.surveylistList) && currentAssignment.surveylistList.length > 0 && Array.isArray(currentAssignment.surveylistList[0].surveyList) && currentAssignment.surveylistList[0].surveyList.length > 0;
  function renderDeploymentInfo() {
    if (!projectAssignments || Array.isArray(projectAssignments) && projectAssignments.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], null);
    }
    if (!hasSurveys) {
      var hasDesignPermissions = Fortress.hasAnyAccess(_questPermissionsByArea["default"].design.permissions, project.groupId);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].noSurveys
      }, /*#__PURE__*/_react["default"].createElement("h3", null, "This Quest has no Surveys."), hasDesignPermissions && /*#__PURE__*/_react["default"].createElement("p", null, "Select a different Quest, or create Surveys in the \"", /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
        to: projectLinks.design
      }, "Design"), "\" tab."));
    }
    return project && deployment && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CycleCard["default"], {
      assignment: currentAssignment,
      cycle: deployment
    }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_DeployTrack["default"], {
      match: match
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].deployWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    showProjectDropdown: true,
    showQuestCount: false,
    showQuestDropdown: true,
    showDeploymentDropdown: true,
    showRepeatableDeploymentChildren: false,
    deploymentDropdownNotMulti: true,
    rightSection: /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].rightSection
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
    }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: hasSurveys ? 'A Data Collection Wave is a specifically configured quest against which data is collected.' : 'You need to add surveys in the "Design" tab before you can create a Data Collection Wave.'
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        disabled: !hasSurveys
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
        spaceRight: true
      }), "Create Data Collection Wave"), hasSurveys && Array.isArray(currentAssignment.deploymentList) && currentAssignment.deploymentList.length === 0 && showArrow && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].bounceArrow, _animate["default"].animated, _animate["default"].bounce, _animate["default"].infinite)
      }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null))),
      title: "New Data Collection Wave",
      size: "large",
      beforeShow: function beforeShow() {
        return setShowArrow(false);
      },
      beforeClose: function beforeClose() {
        return setShowArrow(true);
      }
    }, hasSurveys && /*#__PURE__*/_react["default"].createElement(_CycleForm["default"], {
      assignment: currentAssignment
    })))
  }), renderDeploymentInfo());
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    project: (0, _admin2.getCurrentProject)(state.assignment.admin),
    assignmentId: state.assignment.admin.currentAssignmentId,
    deployment: (0, _admin2.getCurrentDeployment)(state.assignment.admin),
    projectAssignments: (0, _admin2.getCurrentProjectAssignments)(state.assignment.admin),
    projectLinks: (0, _admin2.getProjectLinks)(state.assignment.admin)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _keepScrollPosition["default"])(Deploy));
exports["default"] = _default;